<template>
  <div
    class="menu-item w-100 d-flex flex-row"
    :class="{ bordered: border }"
    @click="$emit('click')"
  >
    <div
      class="col-8 mx-auto d-flex align-items-start flex-column justify-content-center text-section"
      style="padding-left: 0.69rem"
    >
      <p class="p-0 m-0">
        {{ text }}
      </p>
      <p v-if="description" class="p-0 m-0">{{ description }}</p>
    </div>
    <div
      class="col-4 d-flex justify-content-end align-content-center align-items-center"
      :class="iconPadding"
      :style="!iconPadding ? 'padding-right: 0.69rem' : ''"
    >
      <img v-if="icon" :src="icon" alt="icon" />
      <span
        v-else-if="materialIcon"
        class="material-symbols-outlined fw-light"
        style="color: #595a5a"
      >
        {{ materialIcon }}
      </span>
      <i v-else class="fa fa-chevron-right p-0" style="margin: auto 0"></i>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MenuItem",
  emits: ["click"],
  props: {
    text: String,
    description: String,
    icon: String,
    materialIcon: String,
    iconPadding: String,
    border: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    return {};
  },
});
</script>

<style lang="scss" scoped>
.menu-item {
  cursor: pointer;
  min-height: 3.5rem;
}

.bordered {
  border: 1px solid #ddd;
}

.text-section {
  s & p {
    color: var(--Typography-Text-2-ICON, #595a5a);

    /* Text regular-content-Page title */
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.625rem; /* 185.714% */
  }

  & p + p {
    color: var(--Typography-Text-2-ICON, #595a5a);
    font-feature-settings: "clig" off, "liga" off;

    /* Text lighter */
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.25rem; /* 142.857% */
  }
}

.pr-dotfive {
  padding-right: 0.5rem !important;
}

img {
  width: 1.3rem;
  height: 1.3rem;
  margin: auto 0;
}
</style>
